export default __webpack_public_path__ + "static/empty-iphone-f93900394916eabc363dbda8a14c0a23.png";